import '../Assests/css/components/nav.css'
function NavBar(){

    return (
<nav className="navbar">
    <div className="nav-logo">JC</div>
    <ul className="nav-links">
        <li><a href="#home">HOME</a></li>
        <li><a href="#about">ABOUT</a></li>
         <li><a href="#achievements">ACHIEVEMENTS</a></li>
        <li><a href="#projects">PROJECTS</a></li>
        <li><a href="#hobbies">HOBBIES</a></li>
    </ul>
</nav>
    );
}

export default NavBar;